import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import { EventClickArg, EventInput } from "@fullcalendar/core";
import { useEffect, useMemo, useState } from "react";
import { parseTasksToEvents } from "../../utils/calendarUtils";
import { useGetTasksQuery } from "../../api/tareas/tareaApi";
import { ModalContainer } from "../UtilitiesComponents/ModalContainer";
import { TaskDetailModal } from "./TaskDetailModal";
import { useLocation } from "react-router";

export function Calendario() {
    const location = useLocation();

    const [tasks, setTasks] = useState<EventInput>([])
    const [showModal, setShowModal] = useState(false);
    const [idTaskSelected, setIdTaskSelected] = useState(0)

    const handleClick = (clickInfo: EventClickArg) => {
        const taskId = parseInt(clickInfo.event.id);
        setShowModal(true);
        setIdTaskSelected(taskId);
    }

    const empresaId = useMemo(() =>
        location.state ? location.state.empresaId : undefined,
        []);

    const { data: calendarInfo } = useGetTasksQuery({ empresaId, formatoFecha: "Numero" }, { refetchOnMountOrArgChange: true });

    useEffect(() => {
        setTasks(parseTasksToEvents(calendarInfo?.tareas ?? []))
    }, [calendarInfo])

    return (
        <>
        <FullCalendar
            eventClick={handleClick}
            height={"100%"}
            aspectRatio={3}
            locale="es"
            headerToolbar={{ center: "dayGridYear,dayGridMonth,dayGridWeek,dayGridDay"}}
            plugins={[ dayGridPlugin ]}
            initialView="dayGridMonth"
            events={tasks}/>

        {showModal && (
        <ModalContainer>
            <TaskDetailModal 
                taskId={idTaskSelected}
                setShowModal={setShowModal}/>
        </ModalContainer>
        )}

        </>
    );
}